import axiosBasicInstance from '../axiosConfig';

const getListDesignation = async (data) => {
   try {
      const response = await axiosBasicInstance.post(`/management/list-designation`, data);
      return response;
   } catch (error) {
      throw error;
   }
};

    const getDesignationDetail = async (data) => {
    try {
        const response = await axiosBasicInstance.post(`/management/designation-detail`, data);
        return response;
    } catch (error) {
        throw error;
    }
    };

const addDesignation = async (data) => {
   try {
      const response = await axiosBasicInstance.post(`/management/add-designation`, data);

      return response;
   } catch (error) {
      throw error;
   }
};

const updateDesignation = async (data) => {
   try {
      const response = await axiosBasicInstance.post(`/management/update-designation`, data);

      return response;
   } catch (error) {
      throw error;
   }
};

const deleteDesignation = async (data) => {
   try {
      const response = await axiosBasicInstance.post(`/management/delete-designation`, data);

      return response;
   } catch (error) {
      throw error;
   }
};

const deleteDesignationAll = async (data) => {
   try {
      const response = await axiosBasicInstance.post(`/management/delete-designation-all`, data);

      return response;
   } catch (error) {
      throw error;
   }
};


export { getListDesignation, getDesignationDetail, addDesignation, updateDesignation, deleteDesignation, deleteDesignationAll };
